var map = {
	"./en/authentication.json": 93484,
	"./en/changeform.json": 18833,
	"./en/common.json": 13772,
	"./en/error.json": 72317,
	"./en/header.json": 49376,
	"./en/home.json": 66325,
	"./en/menu.json": 76056,
	"./en/newcomer.json": 4803,
	"./en/register.json": 42682,
	"./th/authentication.json": 24089,
	"./th/changeform.json": 41149,
	"./th/common.json": 98129,
	"./th/error.json": 59506,
	"./th/header.json": 67352,
	"./th/home.json": 30994,
	"./th/menu.json": 71083,
	"./th/newcomer.json": 81651,
	"./th/register.json": 9125
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48527;